var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-uni-button',{staticClass:"tn-btn-class tn-btn",class:[
      _vm.buttonClass,
      _vm.backgroundColorClass,
      _vm.fontColorClass
    ],style:([_vm.buttonStyle]),attrs:{"hover-class":"tn-hover","loading":_vm.loading,"disabled":_vm.disabled,"form-type":_vm.formType,"open-type":_vm.openType},on:{"getuserinfo":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.handleGetUserInfo).apply(void 0, arguments)
},"getphonenumber":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.handleGetPhoneNumber).apply(void 0, arguments)
},"contact":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.handleContact).apply(void 0, arguments)
},"error":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.handleError).apply(void 0, arguments)
},"click":function($event){
arguments[0] = $event = _vm.$handleEvent($event);
(_vm.handleClick).apply(void 0, arguments)
}}},[_vm._t("default")],2)}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }